import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { buildSignalTileReducer } from 'widgets/signalTiles/signalTile/state/reducer';
import {
    buildSignalTileConfigSlice,
    useSignalTileConfigSlice,
} from 'widgets/signalTiles/signalTile/state/config/configslice';
import { buildSignalTileStreamSlice } from 'widgets/signalTiles/signalTile/state/stream/streamSlice';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import { ShowDataFor } from 'utils/components/ShowDataFor/ShowDataFor';

export interface PfeTileTimeSeriesDataItem {
    pfe: number;
}

export const initialPfeTileConfigState: SignalTileConfigState = {
    numWindows: 20,
    bucketSize: 5,
    showDataFor: ShowDataFor.AllDay,
};

export const selectPfeTilesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.PFE_TILE];

export const selectPfeTileState = (state: State, widgetKey: string) =>
    selectPfeTilesState(state)[widgetKey];

export const mapPfeTimeSeriesDataItem = (item: PfeTileTimeSeriesDataItem) => ({
    value: item.pfe,
});

export const pfeTileReducer = buildSignalTileReducer(
    WidgetType.PFE_TILE,
    selectPfeTileState,
    initialPfeTileConfigState
);

export const pfeConfigSlice = buildSignalTileConfigSlice(
    WidgetType.PFE_TILE,
    selectPfeTileState,
    initialPfeTileConfigState
);

export const usePfeTileConfigSlice = () =>
    useSignalTileConfigSlice(
        WidgetType.PFE_TILE,
        selectPfeTileState,
        initialPfeTileConfigState
    );

const selectPfeStreamsState = (state: State) =>
    selectStreamedDataState(state).pfeTiles;

const buildPfeStreamSlice = () =>
    buildSignalTileStreamSlice(
        WidgetType.PFE_TILE,
        'startPfeStream',
        selectPfeStreamsState,
        mapPfeTimeSeriesDataItem,
        initialPfeTileConfigState
    );

const { reducer: pfeStreamDataReducer, selectors: pfeStreamedDataSelectors } =
    buildPfeStreamSlice();

export { pfeStreamDataReducer, pfeStreamedDataSelectors };
